(function () {

    const section    = document.querySelector('.tc-section');

    // Blok wystepuje tylko na wybranych szablonach. Bez tego warunku
    // kolejna linia wolala querySelector na null i przerywala wykonanie
    // calego bundla - moduly importowane pozniej nigdy sie nie inicjowaly.
    if (!section) return;
    const wrapper    = section.querySelector('.tc-wrapper');
    const track      = section.querySelector('.tc-track');
    const prevBtn    = section.querySelector('.tc-prev');
    const nextBtn    = section.querySelector('.tc-next');
    const visStart   = section.querySelector('.tc-visible-start');
    const visEnd     = section.querySelector('.tc-visible-end');
    const scrollArea = section.querySelector('.tc-scroll-area');
    const stickyCol  = section.querySelector('.tc-sticky-col');

    const cols  = track ? Array.from(track.querySelectorAll('.tc-product-col')) : [];
    const total = cols.length;
    let current = 0;

    // ── Breakpointy widocznych kolumn ────────────────────────────────
    function getDesktopVisible() {
        const w = window.innerWidth;
        if (w >= 1200) return 4;
        if (w >= 900)  return 3;
        return 2;
    }

    function setColWidths() {
        if (!wrapper) return;
        const wrapperW = wrapper.offsetWidth;
        const visible  = getDesktopVisible();
        const stickyW  = Math.round(wrapperW / (visible + 1));
        const colW     = Math.round((wrapperW - stickyW) / visible);
        section.style.setProperty('--tc-col-width', colW + 'px');
        stickyCol.style.width = stickyW + 'px';
    }

function equalizeRowHeights() {
    // Wyrównaj nagłówki produktów + sticky header
    const headers = Array.from(section.querySelectorAll('.tc-product-header'));
    headers.forEach(h => h.style.height = '');
    const stickyHeader = section.querySelector('.tc-sticky-header');
    if (stickyHeader) stickyHeader.style.height = '';

    const maxHeaderH = Math.max(...headers.map(h => h.offsetHeight));
    headers.forEach(h => h.style.height = maxHeaderH + 'px');
    if (stickyHeader) stickyHeader.style.height = maxHeaderH + 'px';

    // Wyrównaj wiersze danych
    const rowCount = section.querySelectorAll('.tc-row-label').length;
    for (let i = 0; i < rowCount; i++) {
        const label = section.querySelector(`.tc-row-label[data-row="${i}"]`);
        const cells = section.querySelectorAll(`.tc-cell[data-row="${i}"]`);
        if (!label) continue;
        label.style.height = '';
        cells.forEach(c => c.style.height = '');
        const heights = [label.offsetHeight];
        cells.forEach(c => heights.push(c.offsetHeight));
        const maxH = Math.max(...heights);
        label.style.height = maxH + 'px';
        cells.forEach(c => c.style.height = maxH + 'px');
    }
}

    function getColW() {
        return cols[0] ? cols[0].offsetWidth : 220;
    }

    function getVisible() {
    return getDesktopVisible();
    }

    function update() {
        if (!track) return;
        const colW    = getColW();
        const visible = getVisible();
        const maxIdx  = Math.max(0, total - visible);
        current = Math.min(Math.max(current, 0), maxIdx);
        track.style.transform = `translateX(-${current * colW}px)`;
        const end = Math.min(current + visible, total);
        if (visStart) visStart.textContent = current + 1;
        if (visEnd)   visEnd.textContent   = end;
        if (prevBtn)  prevBtn.disabled = current === 0;
        if (nextBtn)  nextBtn.disabled = current >= maxIdx;
    }

    // ── Skocz do produktu po short (desktop) ────────────────────────
    function scrollToProduct(short) {
        const idx = cols.findIndex(c => c.dataset.short === short.toLowerCase());
        if (idx === -1) return;
        const visible = getVisible();
        // Wyśrodkuj produkt jeśli możliwe
        current = Math.max(0, Math.min(idx, total - visible));
        update();

        // Podświetl kolumnę
        cols.forEach(c => c.classList.remove('is-highlighted'));
        cols[idx].classList.add('is-highlighted');
        setTimeout(() => cols[idx].classList.remove('is-highlighted'), 2000);
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { current--; update(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { current++; update(); });

    if (scrollArea) {
        let touchStartX = 0, touchDeltaX = 0;
        scrollArea.addEventListener('touchstart', (e) => {
            touchStartX = e.touches[0].clientX;
            touchDeltaX = 0;
            track.classList.add('is-dragging');
        }, { passive: true });
        scrollArea.addEventListener('touchmove', (e) => {
            touchDeltaX = e.touches[0].clientX - touchStartX;
            track.style.transform = `translateX(-${current * getColW() - touchDeltaX}px)`;
        }, { passive: true });
        scrollArea.addEventListener('touchend', () => {
            track.classList.remove('is-dragging');
            if (touchDeltaX < -getColW() * 0.25) current++;
            else if (touchDeltaX > getColW() * 0.25) current--;
            update();
        });
    }

    // ════════════════════════════════════════════════════════════════
    // MOBILE
    // ════════════════════════════════════════════════════════════════
    const mobSection  = section.querySelector('.tc-mobile');
    const mobTracks   = mobSection
        ? Array.from(mobSection.querySelectorAll('.tc-mob-track, .tc-mob-headers-track'))
        : [];
    const mobPrev     = section.querySelector('.tc-mob-prev');
    const mobNext     = section.querySelector('.tc-mob-next');
    const mobStart    = section.querySelector('.tc-mob-start');
    const mobEnd      = section.querySelector('.tc-mob-end');
    const MOB_VISIBLE = 2;
    let mobCurrent    = 0;
    const mobTotal    = total;

    function getMobColW() {
        const firstCell = mobSection ? mobSection.querySelector('.tc-mob-cell') : null;
        return firstCell ? firstCell.offsetWidth : 150;
    }

    function updateMob() {
        const colW   = getMobColW();
        const maxIdx = Math.max(0, mobTotal - MOB_VISIBLE);
        mobCurrent   = Math.min(Math.max(mobCurrent, 0), maxIdx);
        mobTracks.forEach(t => {
            t.style.transform = `translateX(-${mobCurrent * colW}px)`;
        });
        const end = Math.min(mobCurrent + MOB_VISIBLE, mobTotal);
        if (mobStart) mobStart.textContent = mobCurrent + 1;
        if (mobEnd)   mobEnd.textContent   = end;
        if (mobPrev)  mobPrev.disabled = mobCurrent === 0;
        if (mobNext)  mobNext.disabled = mobCurrent >= maxIdx;
    }

    // ── Skocz do produktu po short (mobile) ─────────────────────────
    function scrollToProductMob(short) {
        const headerCells = mobSection
            ? Array.from(mobSection.querySelectorAll('.tc-mob-header-cell'))
            : [];
        const idx = headerCells.findIndex(c => c.dataset.short === short.toLowerCase());
        if (idx === -1) return;
        mobCurrent = Math.max(0, Math.min(idx, mobTotal - MOB_VISIBLE));
        updateMob();

        // Podświetl
        const allCells = mobSection.querySelectorAll(`.tc-mob-header-cell, .tc-mob-cell`);
        allCells.forEach(c => c.classList.remove('is-highlighted'));
        mobSection.querySelectorAll(`[data-short="${short.toLowerCase()}"]`)
            .forEach(c => c.classList.add('is-highlighted'));
        setTimeout(() => {
            mobSection.querySelectorAll('.is-highlighted')
                .forEach(c => c.classList.remove('is-highlighted'));
        }, 2000);
    }

    if (mobPrev) mobPrev.addEventListener('click', () => { mobCurrent--; updateMob(); });
    if (mobNext) mobNext.addEventListener('click', () => { mobCurrent++; updateMob(); });

    if (mobSection) {
        let mTouchStartX = 0, mTouchDeltaX = 0;
        mobSection.addEventListener('touchstart', (e) => {
            mTouchStartX = e.touches[0].clientX;
            mTouchDeltaX = 0;
            mobTracks.forEach(t => t.classList.add('is-dragging'));
        }, { passive: true });
        mobSection.addEventListener('touchmove', (e) => {
            mTouchDeltaX = e.touches[0].clientX - mTouchStartX;
            const colW = getMobColW();
            mobTracks.forEach(t => {
                t.style.transform = `translateX(-${mobCurrent * colW - mTouchDeltaX}px)`;
            });
        }, { passive: true });
        mobSection.addEventListener('touchend', () => {
            mobTracks.forEach(t => t.classList.remove('is-dragging'));
            const threshold = getMobColW() * 0.25;
            if (mTouchDeltaX < -threshold) mobCurrent++;
            else if (mTouchDeltaX > threshold) mobCurrent--;
            updateMob();
        });
    }

    // ════════════════════════════════════════════════════════════════
    // HASH — scroll do sekcji + podświetlenie produktu
    // np. #porownanie-lm  lub  #porownanie
    // ════════════════════════════════════════════════════════════════
    function handleHash() {
        const hash = window.location.hash.replace('#', '');
        if (!hash) return;

        const prefix = section.id + '-'; // "porownanie-"

        if (hash === section.id) {
            // Tylko scroll do sekcji
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }

        if (hash.startsWith(prefix)) {
            const short = hash.slice(prefix.length); // "lm", "hm" itd.
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });

            // Krótkie opóźnienie żeby scroll zdążył się skończyć przed animacją
            setTimeout(() => {
                if (window.innerWidth > 768) {
                    scrollToProduct(short);
                } else {
                    scrollToProductMob(short);
                }
            }, 600);
        }
    }

    // ── Init & resize ────────────────────────────────────────────────
    function init() {
        if (window.innerWidth > 768) {
            setColWidths();
            equalizeRowHeights();
            update();
        } else {
            updateMob();
        }
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(init, 100);
    });

    window.addEventListener('hashchange', handleHash);

    init();

    // Obsłuż hash który już jest w URL przy załadowaniu strony
    if (window.location.hash) {
        setTimeout(handleHash, 300);
    }

})();

